import styled from "styled-components";
export const ContentSectionWrapper = styled.section`
  min-height: 70vh;
`;
